/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateOutlookVerificationKeyInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type CreateOutlookVerificationKeyMutationVariables = {|
  input: CreateOutlookVerificationKeyInput
|};
export type CreateOutlookVerificationKeyMutationResponse = {|
  +createOutlookVerificationKey: ?{|
    +key: ?string
  |}
|};
export type CreateOutlookVerificationKeyMutation = {|
  variables: CreateOutlookVerificationKeyMutationVariables,
  response: CreateOutlookVerificationKeyMutationResponse,
|};
*/


/*
mutation CreateOutlookVerificationKeyMutation(
  $input: CreateOutlookVerificationKeyInput!
) {
  createOutlookVerificationKey(input: $input) {
    key
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOutlookVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOutlookVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOutlookVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOutlookVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOutlookVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateOutlookVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOutlookVerificationKeyMutation(\n  $input: CreateOutlookVerificationKeyInput!\n) {\n  createOutlookVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1a9af3ad49bea7c856cad2a22ee1e136';

module.exports = node;
